/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollSmoother } from "gsap/ScrollSmoother";
// gsap.registerPlugin(ScrollTrigger);
import './modules/getUrlParams';
// import imagesLoaded from 'imagesloaded';
import { mobileNav } from './modules/mobileNav';
import { installGallerySlider } from './modules/gallerySlider';
import { productSlider } from './modules/productSlider';
// import { featuredSlider } from './modules/featuredSlider';
// import { columnSlider } from './modules/columnSlider';
import { storiesSlider } from './modules/storiesSlider';
import { accessoriesSlider } from './modules/accessoriesSlider';
import { testimonialsSlider } from './modules/testimonialsSlider';
import { cardSlider } from './modules/cardSlider';
import { filtersSlider } from './modules/filtersSlider';
// import { productFiltersSlider } from './modules/productFiltersSlider';
import { tabsNavSlider } from './modules/tabsNavSlider';
import { octaneProductSlider } from './modules/octaneProductSlider';
import { fancyTabs } from './modules/fancyTabs';
import { timelineSlider } from './modules/timelineSlider';
import { productImagesSlider } from './modules/productImagesSlider';
import { galleryPopup } from './modules/galleryPopup';
import { specsToggle } from './modules/specsToggle';
import { imageSlider } from './modules/imageSlider';
import { spinPopup } from './modules/spinPopup';

// Inline Video Controls
// import './modules/controlVideo';
function controlVideo() {

  // new way using async/await TODO: figure out how to get babel to transpile correctly for IE11 (or, change async function)
  var videoElem = document.getElementById("hero__bRoll");
  var fullVideo = document.getElementById('heroVideo__full');
  var bRoll = videoElem;
  var placeholderImg = document.getElementById("manual-placeholder");
  var placeholderPicture = document.querySelector(".hero__placeholderPicture");
  var playButton = document.querySelector(".playPauseVideo");

  // fade in the placeholder (this let's us have custom placeholders instead of the poster)
  // TO do - progmatically find out when this will load and fade in at that point
  setTimeout(function () {
    placeholderPicture.classList.add('hero__placeholderPicture--loaded')
  }, 100);

  playButton.addEventListener("click", handlePlayButton, false);
  playVideo();

  async function playVideo() {
    try {
      await videoElem.play();
      placeholderImg.classList.add("hero__placeholderImg--playing");
      playButton.classList.add("playPauseVideo--playing");
    } catch (err) {
      placeholderImg.classList.remove("hero__placeholderImg--playing");
      playButton.classList.remove("playPauseVideo--playing");
    }
  }

  function handlePlayButton() {
    if (videoElem.paused) {
      playVideo();
    } else {
      videoElem.pause();
      playButton.classList.remove("playPauseVideo--playing");
    }
  }

  // pause video on esc
  document.onkeydown = function (evt) {
    evt = evt || window.event;
    if (evt.keyCode == 27) {
      handlePlayButton();
    }
  };

  // Popup
  $(".playVideo").magnificPopup({
    type: "inline",
    midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
    callbacks: {
      open: function () {
        bRoll.pause();
        fullVideo.play();
        playButton.classList.remove("playPauseVideo--playing");
      },
      close: function () {
        fullVideo.pause();
        bRoll.play();
        playButton.classList.add("playPauseVideo--playing");
      }
    }
  });
}
var heroVideoExists = document.getElementById('hero__bRoll');
if (heroVideoExists) {
  controlVideo();
}

// alert('test again');

// Cursor stuff
// import Cursor from "./modules/cursor";
// import Magnetic from "./modules/magnetic";

$('.customize__option').on('click tap', function() {
  var imageTarget = $(this).attr('data-target');

  // $('.customize__toggle').removeClass('active');
  $(this).closest('.section').find('.customize__toggle').removeClass('active');

  // $('.customize__description').slideUp();
  $(this).closest('.section').find('.customize__description').slideUp();

  $(this).parent().addClass('active');
  $(this).parent().find('.customize__description').slideDown();

  // $('.customize__image').hide();
  $(this).closest('.section').find('.customize__image').hide();
  $('.customize__image[data-image-id=' + imageTarget + ']').show();
});



// setTimeout(() => {
// imagesLoaded(document.querySelector('#page'), { background: true }, function (instance) {
  // Load stuff after all the images in the body load
  var ctaSliderExists = document.querySelector('.ctas__slider');
  if (ctaSliderExists) {
    ctaSlider();
  }

  var imageSliderExists = document.querySelector('.gallery__slider');
  if (imageSliderExists) {
    imageSlider();
  }

  // var columnSliderExists = document.querySelector('.columnSlider');
  // if (columnSliderExists) {
  //   columnSlider();
  // }

  var productSliderExists = document.querySelector('.product__slider');
  if (productSliderExists) {
    productSlider();
  }

  var octaneProductSliderExists = document.querySelector('.octaneProductSlider');
  if (octaneProductSliderExists) {
    octaneProductSlider();
  }

  // var featuredSliderExists = document.querySelector('.featured__slider');
  // if (featuredSliderExists) {
  //   featuredSlider();
  // }

  var storiesSliderExists = document.querySelector('.stories__slider');
  if (storiesSliderExists) {
    storiesSlider();
  }

  var accessoriesSliderExists = document.querySelector('.accessories__slider');
  if (accessoriesSliderExists) {
    accessoriesSlider();
  }

  var testimonialsSliderExists = document.querySelector('.testimonials__slider');
  if (testimonialsSliderExists) {
    testimonialsSlider();
  }

  var cardSliderExists = document.querySelector('.cards--slider');
  if (cardSliderExists) {
    cardSlider();
  }

  var filtersSliderExists = document.querySelector('.filters--slider');
  if (filtersSliderExists) {
    filtersSlider();
  }

  var tabsNavSliderExists = document.querySelector('.tabs__nav');
  if (tabsNavSliderExists) {
    tabsNavSlider();
  }

  var timelineSliderExists = document.querySelector('.timeline__slider');
  if (timelineSliderExists) {
    timelineSlider();
  }

  var productImagesSliderExists = document.querySelector('.productInfo__mediaSlider');
  if (productImagesSliderExists) {
    productImagesSlider();
  }

  // var galleryPopupExists = document.querySelector('.galleryPopupLink');
  // if  (galleryPopupExists) {
  //  galleryPopup();
  // }

  var gallerySliderExists = document.querySelector('.single-installs');
  if  (gallerySliderExists) {
    installGallerySlider();
  }

  var fancyTabsExists = document.querySelector('.tabs__nav');
  if (fancyTabsExists) {
    setTimeout(() => {
      fancyTabs();
    }, 250);
  }
// });
// }, 3000);



// Animate On Scroll
// import { animateOnScroll } from './modules/animateOnScroll.js';
// animateOnScroll();

// Don't load on mobile
function is_touch_enabled() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

var specsToggleExists = document.querySelector('.tabs__toggle');
if (specsToggleExists) {
  specsToggle();
}

// Mobile vs. Desktop controls
if( ! is_touch_enabled() ) {
  // Set up cursor
  // const cursor = new Cursor();
  // $('[data-magnetic]').each(function () {new Magnetic(this);});

  // gsap.utils.toArray(".product__inspirationButton").forEach(function (button, i) {
  //   button.addEventListener("click", (e) => {
  //     var id = e.target.getAttribute("href");
  //     smoother.scrollTo(id, true, "top top");
  //     e.preventDefault();
  //   });
  // });

  // let urlHash = window.location.href.split("#")[1];
  // let scrollElem = document.querySelector("#" + urlHash);

  // if (urlHash && scrollElem) {
  //   gsap.to(smoother, {
  //     scrollTop: smoother.offset(scrollElem, "top top"),
  //     duration: 0.5
  //   });
  // }

} else {
  $('body').addClass('touch');
  $('.featured__mobileNav').on('click tap', function() {
    $(this).toggleClass('open');
    $('.featured__mobileNav .featured__nav').slideToggle();
  });

  $('.featured__mobileNav .featured__navItem').on('click tap', function() {
    // Save targeted info
    var icon = $(this).find('img').attr('src');
    var label = $(this).find('span').text();
    var tab = $(this).attr('data-tab-target');

    $('.featured__navItem').removeClass('hiding');
    $(this).addClass('hiding');

    // Update selected info
    $('.featured__navSelected').find('img').attr('src', icon);
    $('.featured__navSelected').find('span').text(label);

    // Show/hide the sliders
    $('div[role=tabpanel]').hide();
    $('div[aria-labelledby=' + tab + ']').show();
  });
}

if (window.innerWidth < 1200) {
  mobileNav();
}

// Load 'em
// import { heroSplitText } from './modules/heroSplitText';
// heroSplitText();

// import { siteCookieControls } from './modules/cookies';
// siteCookieControls();

import { popup } from './modules/popup';
popup();

import { contactForm } from './modules/contactForm';
contactForm();

import { toggles } from './modules/toggle';
toggles();

import { anchorLinks } from './modules/anchors';
import { ctaSlider } from './modules/ctaSlider';
import { getUrlParams } from './modules/getUrlParams';
anchorLinks();

var spinPopupExists = document.querySelector('.spinPopupLink');
if (spinPopupExists) {
  spinPopup();
}

$('.testimonialsCTA__formContainer').hide();
$('.testimonialsCTA__link').on('click tap', function(e) {
  e.preventDefault();
  $(this).toggleClass('active');
  $('.testimonialsCTA__formContainer').slideToggle();
});

// Search
$('.siteHeader__searchIcon').on('click tap', function() {
  // $('body').addClass('search-open');
  $(this).hide();
  $('.siteHeader__closeSearch').show();
  $('.siteHeader__search').addClass('open');
  setTimeout(() => {
    $('.swp-input--search').focus();
  }, 1000);
});

$('.siteHeader__closeSearch').on('click tap', function() {
  // $('body').removeClass('search-open');
  $(this).hide();
  $('.siteHeader__searchIcon').show();
  $('.siteHeader__search').removeClass('open');
});

// Mobile Filters
$('.collection__mobileFiltersTrigger').on('click tap', function() {
  $('.collection__filters').addClass('show');
  $('body').addClass('fixed');
});

$('.collection__filterClose').on('click tap', function() {
  $('.collection__filters').removeClass('show');
  $('body').removeClass('fixed');
});

$('.collection__filterSubmit').on('click tap', function() {
  $('.collection__filters').removeClass('show');
});

// Refire stuff on window resize
var timeout = false, // holder for timeout id
    delay   = 250; // delay after event is "complete" to run callback

// window.resize event listener
window.addEventListener('resize', function () {
  // clear the timeout
  clearTimeout(timeout);
  // start timing for event "completion"
  // timeout = setTimeout(function () {
  //   ScrollTrigger.refresh();
  // }, delay);
});

// FAQS
$('.faqs__answer').hide();
$('.faqs__question').on('click tap', function() {
  $(this).parent().toggleClass('active');
  $(this).parent().find('.faqs__answer').slideToggle();
});

// Nav dropdown
// $(".mainNav").hover(
//   function() {
//     // alert('hovering');
//     $(".mainNav__listItem").on( "mouseenter", function() {
//       var subListHeight = $(this).find('.mainNav__subListContainer');
//         alert(subListHeight);
//     });
//   }, function() {
//     // alert('stopped hovering');
//   }
// );

if (window.innerWidth < 960) {
  $('.products-filter.alm-filter').on('click tap', function() {
    $(this).toggleClass('open');
    $(this).children('.alm-filter--inner').toggle();
  });
}

window.almComplete = function(alm){
	var galleryPopupExists = document.querySelector('.galleryPopupLink');
  if  (galleryPopupExists) {
   galleryPopup();
  }
  // var installTarget = getUrlParams()["install"];
  // setTimeout(() => {
  //   $('.galleryPopupLink#' + installTarget).trigger('click');
  // }, 1000);
  // var productFiltersSliderExists = document.querySelector('.alm-filter--checkbox');
  // if (productFiltersSliderExists) {
  //   productFiltersSlider();
  // }
};
